module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"lifespanTitle":"Lebensdauer","nameTitle":"Komponente","yearsUnit":"Jahre","components":{"basement":"Keller / Kellerdecke","heating":"Wärmeerzeuger","heating_distribution":"Wärmeverteilung","pv":"Photovoltaikanlage","roof_flat":"Flachdach","roof_gable":"Schrägdach","walls":"Fassade","windows":"Fenster"}}}')
  delete Component.options._Ctor
}
